import { render, staticRenderFns } from "./TemplateInfoStatistic.vue?vue&type=template&id=1744c0c9&scoped=true"
import script from "./TemplateInfoStatistic.vue?vue&type=script&lang=js"
export * from "./TemplateInfoStatistic.vue?vue&type=script&lang=js"
import style0 from "./TemplateInfoStatistic.vue?vue&type=style&index=0&id=1744c0c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1744c0c9",
  null
  
)

export default component.exports